export const ABP_TENANT_COOKIE = 'Abp.TenantId'
export const ABP_CULTURE_COOKIE = 'Abp.Localization.CultureName'
export const ABP_AUTH_TOKEN_STORAGE = 'buxus-web-abp-auth-token'
export const ABP_USER_ID_STORAGE = 'buxus-web-abp-user-id'
export const ABP_BOOTSTRAP_STORAGE = 'buxus-web-abp-bootstrap-v1'

/** Buxus platform API (buxusplatform-backend at verify.buxus.io). */
const BUXUS_API_ROOT = 'https://verify.buxus.io'

/**
 * Base URL for all Buxus platform REST calls — fixed at build time from `.env.*`.
 * See `apps/web/.env.staging` / `.env.production` / `.env.development`.
 */
export const BUXUS_API_BASE_URL =
  (import.meta.env.VITE_BUXUS_API_BASE_URL as string | undefined)?.trim() || `${BUXUS_API_ROOT}/api`

export const DISCOVER_LOGIN_METHOD_URL = `${BUXUS_API_BASE_URL}/account/discover-login-method`

export const MY_PROFILE_URL = `${BUXUS_API_BASE_URL}/account/my-profile`
export const LOGOUT_URL = `${BUXUS_API_BASE_URL}/account/logout`
export const APPLICATION_CONFIGURATION_URL = `${BUXUS_API_BASE_URL}/abp/application-configuration`
export const CURRENT_LOGIN_INFORMATIONS_URL = `${BUXUS_API_BASE_URL}/session/current-login-informations`

export const BUXUS_GET_ALL_OPERATORS_WITH_VERSION_URL = `${BUXUS_API_BASE_URL}/buxus/get-all-operators-with-version`
export const BUXUS_GET_TRAINING_DOCUMENTS_URL = `${BUXUS_API_BASE_URL}/buxus/get-training-documents`

export const BUXUS_PREVIEW_ALERT_URL = `${BUXUS_API_BASE_URL}/buxus/preview-alert`
export const BUXUS_SEND_ALERT_URL = `${BUXUS_API_BASE_URL}/buxus/send-alert`

/** Default webhook token; set `VITE_BUXUS_WEBHOOK_TOKEN` to override. */
export const BUXUS_WEBHOOK_TOKEN =
  (import.meta.env.VITE_BUXUS_WEBHOOK_TOKEN as string | undefined)?.trim() || 'grover'

export const GET_REGISTRATION_PROFILE_URL = `${BUXUS_API_BASE_URL}/buxus/get-registration-profile`
export const REGISTRATION_FIND_USER_BY_EMAIL_URL = `${BUXUS_API_BASE_URL}/user/find-by-email-in-buxus`
export const REGISTRATION_REGISTER_BUXUS_URL = `${BUXUS_API_BASE_URL}/account/register-buxus`
export const REGISTRATION_ACCOUNT_SETUP_CRM_URL = `${BUXUS_API_BASE_URL}/buxus/account-setup-crm`
export const REGISTRATION_QUICK_CODE_LOOKUP_URL = `${BUXUS_API_BASE_URL}/buxus/get-by-quickcode-computed`
export const REGISTRATION_SEND_RESPONDER_INVITES_URL = `${BUXUS_API_BASE_URL}/buxus/send-responder-invites`
export const BUXUS_MAKE_REQUEST_URL = `${BUXUS_API_BASE_URL}/buxus/make-request`
export const REGISTRATION_TENANT_ID =
  (import.meta.env.VITE_BUXUS_TENANT_ID as string | undefined)?.trim() ||
  '6F2DC493-F969-EBF2-C336-3A12515B7BDD'

/** Persisted operator downloads (payload only; SAS tokens are not stored). Cleared on logout. */
export const OPERATOR_SESSION_STORAGE_KEY = 'buxus-web-operator-session-v1'

/** `stakeholderType` string from get-registration-profile (for "(Default)" in stakeholder menu). */
export const PROFILE_STAKEHOLDER_STORAGE_KEY = 'buxus-web-profile-stakeholder-v1'

/** JSON string array of `"County - ST"` keys from registration jurisdiction (asset list filtering). */
export const PROFILE_JURISDICTION_STORAGE_KEY = 'buxus-web-profile-jurisdiction-v1'

export const HELP_OFFSITE_URL = 'https://buxus.io/help'
